import {Route} from '~utils/routeUtil';
import {LabelItem} from '~redux/types/images';

import {ItemsPerPageOption} from '~components/images/image-overview/header/ItemsPerPageSelect';

// default class labels
export const CLASS_EMPTY = 'EMPTY';
export const CLASS_OK = 'OK';
export const CLASS_NOK = 'NOK';
export const UNLABELED = 'UNLABELED';
export const ANOMALY = 'ANOMALY';

// In the backend, label IDs are suffixed by the model ID, separated by this separator
// e.g. <label>__<modelID>
export const LABEL_ID_SEPARATOR = '__';

// Retry requests on these status codes (applies to ky)
// see also https://github.com/sindresorhus/ky#retry
export const API_RETRY_STATUS_CODES = [413, 429, 500, 502, 503, 504];
export const API_RETRY_COUNT = 1;

export const IMAGE_SORT_ORDER_DELIMITER = '__';

export const MIN_LABEL_DISTRIBUTION_CHART_HEIGHT = 250;

export const DEFAULT_SHORT_LABEL_CHAR_LENGTH = 40;

export const IMAGE_OVERVIEW_ITEMS_PER_PAGE: ItemsPerPageOption = 100;
export const MAX_IMAGES_TOTAL = 10000;
/** Max items selectable via gallery "select all" / bulk_ids (matches backend cap). */
export const MAX_GALLERY_SELECTABLE = MAX_IMAGES_TOTAL;
export const IMAGES_UPLOAD_CHUNK = 100;
export const TOP_FIRST_N_IMAGES_INTERNAL = 10000;
export const TOP_FIRST_N_IMAGES_EXTERNAL = 1000;
export const THUMBNAIL_BORDER_WIDTH = 4;
export const THUMBNAIL_MAX_HEIGHT = 120;
export const THUMBNAIL_MIN_WIDTH = 244;

export const MIN_IMAGES_FOR_TRAINING = 10;
export const MIN_OK_IMAGES_FOR_TRAINING = 5;

export const MINIMUM_DATE_FOR_TIMEFRAME = new Date(2020, 0, 1);

export const DONT_SHOW_AGAIN_KEYS = 'dontShowAgainKeys';

export const TIME_FORMAT = 'HHmm';

export const UNKNOWN_MODEL_ID = '__UNKNOWN_MODEL_ID__';

export const KEYPOINT_DETECTION_FOUND_LABEL: LabelItem = {
  id: '__KEYPOINTS_DETECTED__',
  alias: 'found',
  colorCode: '#2FC97B',
  type: 'keypoint',
  condition: 'OK',
};

export const KEYPOINT_DETECTION_NOT_FOUND_LABEL: LabelItem = {
  id: '__NO_KEYPOINTS_DETECTED__',
  alias: 'notFound',
  colorCode: '#565656',
  type: 'keypoint',
  condition: 'NOK',
};

export const NO_DEFECTS_KEY = '#CONDITION_NO_DEFECTS';
export const NO_OBJECTS_KEY = '#CONDITION_NO_OBJECTS';
export const NO_ANNOTATED_KEY = '#CONDITION_NO_ANNOTATED';

export const META_NOT_FILTERABLE = [
  'record_to_save_time',
  'polygon_time',
  'polygons_time',
  'model_time',
  'model_error',
] as const;

export const PORTAL_ROOT_ID = 'portal-root';
export const ANNOTATOR_PORTAL_ROOT_ID = 'annotator-portal-root';
export const ANNOTATOR_FULLSCREEN_TOASTER_ID = 'annotator-fullscreen';

// The precision is defined by the backend
export const FINETUNE_CONFIDENCE_THRESHOLD_PRECISION = 3;

export const OFFLINE_THRESHOLD_IN_SECONDS = 30 * 60;

export const INTERCOM_USER_GUIDE_ID_EN = 52566192;
export const INTERCOM_USER_GUIDE_ID_DE = 57953888;

export const NAVIGATION_MAP: {
  [key: string]: string | null;
} = {
  // [ChildRoute]: ParentRoute
  [Route.modelSettings]: Route.modelSamples,
  [Route.modelSamplesImage]: Route.modelSamples,
  [Route.modelAddSamples]: Route.modelSamples,
  [Route.modelAddSamplesImage]: Route.modelAddSamples,
  [Route.modelSamples]: Route.models,
  [Route.modelLabelDistribution]: Route.modelSamples,
  [Route.modelFinetune]: Route.modelTraining,
  [Route.modelFinetuneImage]: Route.modelFinetune,
  [Route.modelFinetuneDeploymentSettings]: Route.modelFinetune,
  [Route.modelFinetuneImproveDataset]: Route.modelFinetune,
  [Route.modelSamplesSmartSelectResults]: Route.modelSamples,
  [Route.modelTraining]: Route.modelSamples,
  [Route.modelLabelNoise]: Route.modelSamples,
  [Route.archiveImage]: Route.archive,
  [Route.tasksSession]: Route.tasks,
  [Route.tasksLiveSession]: Route.tasks,
};
